import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Card, PageHeader, Row, Col, Button, Divider, Typography, Skeleton } from "antd";
import Filters, { FilterItem, Types } from "../../components/Filters";
import { RegisterShelterForm, ShelterForm } from "../../components/Forms";
import ShelterList from "../../components/ShelterList";
import {
  QuestionProvider,
  QuestionConsumer,
} from "../../context/QuestionContext";
import {
  QuestionTemplateProvider,
  QuestionTemplateConsumer,
} from "../../context/QuestionTemplateContext";
import { SpecieProvider, SpecieConsumer } from "../../context/SpecieContext";
import { GroupProvider, GroupConsumer } from "../../context/GroupContext";
import {
  ShelterSettingProvider,
  ShelterSettingConsumer,
} from "../../context/ShelterSettingContext";
import { PetProvider, PetConsumer } from "../../context/PetContext";
import { ShelterProductProvider } from "../../context/ShelterProductContext";
import { ShelterTaxProvider } from "../../context/ShelterTaxContext";
import {
  PaymentModelProvider,
  PaymentModelConsumer,
} from "../../context/PaymentModelContext";
import { ShelterProvider, ShelterConsumer } from "../../context/ShelterContext";
import {
  LanguageProvider,
  LanguageConsumer,
} from "../../context/LanguageContext";
import { KioskConsumer, KioskProvider } from "../../context/KioskContext";
import {
  ShelterKioskReasonConsumer,
  ShelterKioskReasonProvider,
} from "../../context/ShelterKioskReasonContext";
import {
  ApplicationTagConsumer,
  ApplicationTagProvider,
} from "../../context/ApplicationTagContext";
import {
  CharacteristicsProvider,
  CharacteristicsConsumer,
} from "../../context/CharacteristicsContext";
import { PetProfileControl } from "components/Forms/Shelter/PetProfileControl";
import { ShelterMenu, ShelterMenuList } from "./MenuList";

export default class Shelter extends Component {

  state = {
    isLoading: true,
    shelter:  {} as any
  }


  private shelterDispatchOptions = {
    search: {
      template: {
        with: true,
      },
    },
    options: {
      sort: ["-active"],
    },
  } as const;

  renderAdd = () => {
    const { permissions }: any = this.props;
    if (!permissions.create) return null;

    return (
      <Link to="shelter/add">
        <Button type="primary" shape="round">
          Add new shelter
        </Button>
      </Link>
    );
  };

  renderForm = (activeTab: string, props: any, extras: any) => {
    switch (activeTab) {
      case "general":
        return (
          <ShelterSettingProvider>
            <LanguageProvider>
              <ShelterSettingConsumer>
                {({
                  fetching,
                  shelterSettings,
                  error,
                  requestShelterSettingList,
                  requestShelterSettingAdoptionPathSave,
                  requestShelterSettingAdopterPersonalDocumentsSave,
                }) => (
                  <ShelterForm.General
                    {...props}
                    error={props.error || error}
                    contentLoading={fetching}
                    shelterAdoptionPathSettings={
                      shelterSettings?.find(
                        (setting) =>
                          setting.type_key === "ADOPTION_PATH_MESSAGE"
                      )?.value
                    }
                    shelterAdopterPersonalDocumentSettings={
                      shelterSettings?.find(
                        (setting) =>
                          setting.type_key === "ADOPTER_PERSONAL_DOCUMENTS"
                      )?.value
                    }
                    loadShelterSetting={requestShelterSettingList}
                    dispatchSaveAdoptionPathSetting={
                      requestShelterSettingAdoptionPathSave
                    }
                    dispatchSaveAdopterPersonalDocumentSetting={
                      requestShelterSettingAdopterPersonalDocumentsSave
                    }
                  />
                )}
              </ShelterSettingConsumer>
            </LanguageProvider>
          </ShelterSettingProvider>
        );
      case "pet-profile":
        return (
          <PetProfileControl
            data={props.data}
            extras={extras}
            uuid={props.uuid}
          />
        );
      case "discount-reason":
        return (
          <ShelterSettingProvider>
            <ShelterSettingConsumer>
              {(context) => (
                <ShelterForm.DiscountReason
                  uuid={props.uuid}
                  context={extras.shelterContext}
                  settingsContext={context}
                />
              )}
            </ShelterSettingConsumer>
          </ShelterSettingProvider>
        );
      // case "limit-control":
      //   return (
      //     <SpecieProvider>
      //       <BreedProvider>
      //         <ShelterSettingProvider>
      //           <SpecieConsumer>
      //             {(specieContext) => (
      //               <BreedConsumer>
      //                 {(breedConsumer) => (
      //                   <ShelterSettingConsumer>
      //                     {(context) => (
      //                       <ShelterForm.LimitControl
      //                         uuid={props.uuid}
      //                         context={extras.shelterContext}
      //                         settingsContext={context}
      //                         specieContext={specieContext}
      //                         breedContext={breedConsumer}
      //                       />
      //                     )}
      //                   </ShelterSettingConsumer>
      //                 )}
      //               </BreedConsumer>
      //             )}
      //           </SpecieConsumer>
      //         </ShelterSettingProvider>
      //       </BreedProvider>
      //     </SpecieProvider>
      //   );
      case "payment":
        return (
          <PaymentModelProvider>
            <PetProvider>
              <PetConsumer>
                {({ fetching: fetchingPets, pagination, requestPetList }) => (
                  <PaymentModelConsumer>
                    {({ fetching, paymentModels, requestPaymentModelList }) => (
                      <ShelterForm.Payment
                        {...props}
                        paymentModels={paymentModels}
                        petsPaginationData={pagination}
                        contentLoading={fetching || fetchingPets}
                        loadPaymentModels={requestPaymentModelList}
                        loadPets={requestPetList}
                        dispatchSave={extras.dispatchSavePaymentConfig}
                      />
                    )}
                  </PaymentModelConsumer>
                )}
              </PetConsumer>
            </PetProvider>
          </PaymentModelProvider>
        );
      case "question":
        return (
          <LanguageProvider>
            <SpecieProvider>
              <QuestionTemplateProvider>
                <QuestionProvider>
                  <LanguageConsumer>
                    {(languageContext) => (
                      <SpecieConsumer>
                        {(speciesContext) => (
                          <QuestionTemplateConsumer>
                            {(questionTemplateContext) => (
                              <QuestionConsumer>
                                {(questionContext) => (
                                  <ShelterForm.Question
                                    shelterUuid={props.uuid}
                                    context={extras.shelterContext}
                                    languageContext={languageContext}
                                    questionContext={questionContext}
                                    questionTemplateContext={
                                      questionTemplateContext
                                    }
                                    speciesContext={speciesContext}
                                  />
                                )}
                              </QuestionConsumer>
                            )}
                          </QuestionTemplateConsumer>
                        )}
                      </SpecieConsumer>
                    )}
                  </LanguageConsumer>
                </QuestionProvider>
              </QuestionTemplateProvider>
            </SpecieProvider>
          </LanguageProvider>
        );
      case "pet-restore":
        return (
          <PetProvider>
            <PetConsumer>
              {({
                fetching,
                pets,
                pagination,
                error,
                requestPetList,
                requestPetRestore,
              }) => (
                <ShelterForm.PetRestore
                  {...props}
                  loading={fetching}
                  pagination={pagination}
                  error={error}
                  pets={pets}
                  shelter={props.data}
                  loadPets={requestPetList}
                  dispatchRestore={requestPetRestore}
                />
              )}
            </PetConsumer>
          </PetProvider>
        );
      case "product":
        return (
          <SpecieProvider>
            <ShelterProductProvider>
              <SpecieConsumer>
                {({ fetching, species, requestSpecieList }) => (
                  <ShelterForm.Product
                    {...props}
                    shelter={props.data}
                    contentLoading={fetching}
                    species={species}
                    loadSpecies={requestSpecieList}
                  />
                )}
              </SpecieConsumer>
            </ShelterProductProvider>
          </SpecieProvider>
        );
      case "tax":
        return (
          <ShelterTaxProvider>
            <ShelterForm.Tax {...props} shelter={props.data} />
          </ShelterTaxProvider>
        );
      case "iframe":
        return (
          <ShelterSettingProvider>
            <SpecieProvider>
              <GroupProvider>
                <ShelterSettingConsumer>
                  {({
                    fetching,
                    shelterSettings,
                    error,
                    requestShelterSettingList,
                    requestShelterSettingIframeSave,
                  }) => (
                    <SpecieConsumer>
                      {({
                        fetching: fetchingSpecies,
                        species,
                        requestSpecieList,
                      }) => (
                        <GroupConsumer>
                          {({
                            fetching: fetchingGroups,
                            groups,
                            requestGroupList,
                          }) => (
                            <ShelterForm.Iframe
                              {...props}
                              data={
                                shelterSettings?.filter(
                                  (setting) => setting.type_key === "IFRAME"
                                )[0]
                              }
                              error={error}
                              loading={fetching}
                              contentLoading={
                                extras.loading ||
                                fetchingSpecies ||
                                fetchingGroups
                              }
                              species={species}
                              groups={groups}
                              shelter={props.data}
                              loadSpecies={requestSpecieList}
                              loadGroups={requestGroupList}
                              loadShelterSetting={requestShelterSettingList}
                              dispatchSave={requestShelterSettingIframeSave}
                            />
                          )}
                        </GroupConsumer>
                      )}
                    </SpecieConsumer>
                  )}
                </ShelterSettingConsumer>
              </GroupProvider>
            </SpecieProvider>
          </ShelterSettingProvider>
        );
      case "kennel-card":
        return (
          <ShelterSettingProvider>
            <ShelterSettingConsumer>
              {({
                fetching,
                error,
                shelterSettings,
                requestShelterSettingList,
                requestShelterSettingKennelCardSave,
              }) => (
                <ShelterForm.KennelCard
                  {...props}
                  data={
                    shelterSettings?.filter(
                      (setting) => setting.type_key === "KENNEL_CARD"
                    )[0]
                  }
                  shelter={props.data}
                  error={error}
                  loading={fetching}
                  contentLoading={extras.loading}
                  loadShelterSetting={requestShelterSettingList}
                  dispatchSave={requestShelterSettingKennelCardSave}
                />
              )}
            </ShelterSettingConsumer>
          </ShelterSettingProvider>
        );
      case "in-person":
        return (
          <ShelterSettingProvider>
            <ShelterSettingConsumer>
              {(context) => (
                <ShelterForm.InPerson
                  uuid={props.uuid}
                  settingsContext={context}
                  context={extras.shelterContext}
                />
              )}
            </ShelterSettingConsumer>
          </ShelterSettingProvider>
        );
      case "kiosk":
        return (
          <LanguageProvider>
            <KioskProvider>
              <ShelterKioskReasonProvider>
                <ShelterKioskReasonConsumer>
                  {(shelterKioskReasonContext) => (
                    <KioskConsumer>
                      {(kioskContext) => (
                        <ShelterForm.Kiosk
                          shelterUuid={props.uuid}
                          branchUuid={extras.entityUuid}
                          history={props.history}
                          kioskContext={kioskContext}
                          shelterKioskReasonContext={shelterKioskReasonContext}
                          context={extras.shelterContext}
                        />
                      )}
                    </KioskConsumer>
                  )}
                </ShelterKioskReasonConsumer>
              </ShelterKioskReasonProvider>
            </KioskProvider>
          </LanguageProvider>
        );
      case "process-tag":
        return (
          <ApplicationTagProvider>
            <ApplicationTagConsumer>
              {(applicationTagContext) => (
                <ShelterForm.ProcessTag
                  shelterUuid={props.uuid}
                  applicationTagContext={applicationTagContext}
                  context={extras.shelterContext}
                />
              )}
            </ApplicationTagConsumer>
          </ApplicationTagProvider>
        );
      case "pet-characteristics":
        return (
          <ShelterSettingProvider>
            <LanguageProvider>
              <CharacteristicsProvider>
                <ShelterSettingConsumer>
                  {({
                    fetching,
                    shelterSettings,
                    error,
                    requestShelterSettingList,
                  }) => (
                    <LanguageConsumer>
                      {({
                        fetching: fetchingLanguages,
                        languages,
                        requestLanguageList,
                      }) => (
                        <CharacteristicsConsumer>
                          {({
                            requestCharacteristics,
                            requestCharacteristicsSave,
                            characteristics,
                          }) => (
                            <ShelterForm.Characteristics
                              {...props}
                              contentLoading={fetching}
                              error={props.error || error}
                              languages={languages}
                              loadingLanguages={fetchingLanguages}
                              loadLanguages={requestLanguageList}
                              loadShelterSetting={requestShelterSettingList}
                              shelterPetCharacteristicsSettings={
                                shelterSettings?.find(
                                  (setting) =>
                                    setting.type_key ===
                                    "PET_CHARACTERISTICS_ALIAS"
                                )?.value
                              }
                              characteristics={characteristics}
                              loadCharacteristics={requestCharacteristics}
                              dispatchSaveCharacteristicsSetting={
                                requestCharacteristicsSave
                              }
                            />
                          )}
                        </CharacteristicsConsumer>
                      )}
                    </LanguageConsumer>
                  )}
                </ShelterSettingConsumer>
              </CharacteristicsProvider>
            </LanguageProvider>
          </ShelterSettingProvider>
        );
      default:
        return (
          <Redirect to={`/organization/shelter/${props.uuid}/general`} exact />
        );
    }
  };

  render() {
    const {
      permissions,
      history,
      goBack,
      match: {
        params: { shelterUuid, activeTab, entityUuid },
      },
    }: any = this.props;

    const filterStatusOptions = [
      {
        value: "true",
        text: "Active",
      },
      {
        value: "false",
        text: "Deactivated",
      },
    ];

    return (
      <ShelterProvider>
        <ShelterConsumer>
          {(context) => {
            const {
              fetching,

              shelters,
              shelter,
              validSlug,

              error,
              pagination,

              requestShelterList,
              requestShelterFind,
              requestShelterCreate,
              requestShelterSave,
              requestShelterVerifySlug,
              requestShelterToggleActive,
              requestShelterQuestionUpdate,
              requestShelterPaymentConfigSave,
            } = context;

            const extras = {
              entityUuid: entityUuid,

              loading: fetching,
              dispatchSaveShelterQuestions: requestShelterQuestionUpdate,
              dispatchSavePaymentConfig: requestShelterPaymentConfigSave,

              shelterContext: context,
            };

            // Edit existing entity
            if (shelterUuid) {
              // Register shelter
              if (shelterUuid === "add") {
                return (
                  <LanguageProvider>
                    <LanguageConsumer>
                      {({
                        fetching: fetchingLanguage,
                        languages,
                        requestLanguageList,
                      }) => (
                        <Card>
                          <PageHeader
                            title="New Shelter"
                            onBack={() => goBack("/organization/shelter")}
                          >
                            <RegisterShelterForm
                              permissions={permissions}
                              data={shelter}
                              languages={languages}
                              validSlug={validSlug}
                              loading={fetching || false}
                              contentLoading={fetchingLanguage}
                              error={error}
                              history={history}
                              loadLanguages={requestLanguageList}
                              verifySlug={requestShelterVerifySlug}
                              dispatchCreate={requestShelterCreate}
                            />
                          </PageHeader>
                        </Card>
                      )}
                    </LanguageConsumer>
                  </LanguageProvider>
                );
              }

              if (!activeTab)
                return (
                  <Redirect
                    to={`/organization/shelter/${shelterUuid}/general`}
                    exact
                  />
                );

              let formProps = {
                uuid: shelterUuid,
                history: history,
                permissions,

                data: shelter as any,
                error: error,

                loading: fetching,

                loadShelter: requestShelterFind,
                dispatchSave: requestShelterSave,
              } as any;
              const activeMenu = ShelterMenuList.find((menu) => activeTab === menu.key)?.label
              const load = async () => {
                const shelterList: Shelter[] = await requestShelterList({
                  search: {
                    uuid: shelterUuid,
                    contract_options: {
                      with: {
                        deleted: false
                      }
                    },
                    organization_question_shelters: {
                      with: {
                        deleted: false,
                        kiosk_reason_id: null,
                        question_shelter_species: {
                          with: true
                        }
                      }
                    },
                    organization_branches: {
                      with: {
                        deleted: false
                      }
                    },
                    shelter_contract: {
                      with: true
                    },
                    country: {
                      with: {
                        default_language: {
                          with: true
                        }
                      }
                    }
                  },
                  options: {
                    _force_ids: true
                  }
                })
                if (shelterList.length > 0) {
                  this.setState({ shelter: shelterList[0],isLoading: false })
                  return
                }

                this.setState({isLoading: false})
              }

              return (
                <>
                  <PageHeader
                    title={ <Typography.Title style={{ fontSize: 20, textTransform: "capitalize", lineHeight: 1, marginBottom: 5 }}>  {this.state.isLoading ?   <Skeleton active title={{width: 200}} paragraph={false} />  : this.state.shelter?.name || "Shelter"  }</Typography.Title>}
                    onBack={() => goBack("/organization/shelter")}
                    extra={<ShelterMenu onLoad={load} shelterUuid={shelterUuid} />}

                  >
                    <Card>
                      <Typography.Title style={{ fontSize: 18 }}>{activeMenu}</Typography.Title>
                      <Divider />
                      <div style={{ marginTop: 20 }}>

                        {this.renderForm(activeTab, formProps, extras)}

                      </div>
                    </Card >
                  </PageHeader>

                </>
              );
            }

            return (
              <>
                <Card title="Filters" style={{ marginBottom: 25 }}>
                  <Filters
                    size="medium"
                    loading={fetching}
                    history={history}
                    defaultSubmitOptions={this.shelterDispatchOptions}
                    submitDispatch={requestShelterList}
                  >
                    {({ values, handleFilterChange }: any) => (
                      <Row gutter={9} style={{ width: "100%" }}>
                        <Col xs={24} md={8}>
                          <FilterItem
                            name="uuid"
                            type={Types.INPUT}
                            placeholder="Filter by UUID"
                            value={values["uuid"]}
                            size="medium"
                            options={{
                              input: {
                                allowClear: true,
                              },
                            }}
                            onChange={handleFilterChange}
                          />
                        </Col>

                        <Col xs={24} md={8}>
                          <FilterItem
                            name="name.ilike"
                            type={Types.INPUT}
                            placeholder="Filter by Name"
                            value={values["name.ilike"]}
                            size="medium"
                            options={{
                              input: {
                                allowClear: true,
                              },
                            }}
                            onChange={handleFilterChange}
                          />
                        </Col>

                        <Col xs={24} md={8}>
                          <FilterItem
                            name="active"
                            type={Types.SELECT}
                            placeholder="Filter by Active"
                            data={filterStatusOptions}
                            value={values["active"]}
                            size="medium"
                            options={{
                              select: {
                                allowClear: true,
                              },
                            }}
                            onChange={handleFilterChange}
                          />
                        </Col>
                      </Row>
                    )}
                  </Filters>
                </Card>

                <Card title="List of Shelters" extra={this.renderAdd()}>
                  <ShelterList
                    searchOptions={this.shelterDispatchOptions}
                    permissions={permissions}
                    history={history}
                    loading={fetching}
                    shelters={shelters}
                    pagination={pagination}
                    loadShelters={requestShelterList}
                    toggleActive={requestShelterToggleActive}
                  />
                </Card>
              </>
            );
          }}
        </ShelterConsumer >
      </ShelterProvider >
    );
  }
}
